import deviceId from './deviceId';
import env from './env';
import { platformStorage } from './storage';

export { deviceId, platformStorage as storage };

export * from './applaunch';
export * from './clipboard';
export * from './deviceId';

// NOTE: './env' stays CommonJS because @bedrock-rdk/config `require`s it from plain Node during
// build-config. `export *` cannot enumerate the names of a CommonJS module, so they are
// re-exported explicitly to keep them statically resolvable for the bundler.
export const {
  appCustomer,
  appEnv,
  appPlatform,
  appVersion,
  isDetectiveApp,
  isDevelopmentApp,
  isProdApp,
  isStagingApp,
  isTestApp,
} = env;
export * from './error';
export * from './event';
export * from './homeId';
export * from './http';
export * from './img';
export * from './object';
export * from './pagination';
export * from './pictos';
export * from './render';
export * from './selector';
export * from './storage';
export * from './string';
export * from './testUtils';
export * from './time';
export * from './timer';
export * from './video';
